export default __webpack_public_path__ + "2c4335ab745f62d0bddd12dce76fc50a.png";